import type { CreateOwnerInput, OwnerListQuery, Page, PayoutDetails, UpdateOwnerInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export interface OwnerListItem {
  id: string;
  name: string;
  payoutMethod: string;
  createdAt: string;
}

export interface OwnerView {
  id: string;
  name: string;
  phone: string | null;
  email: string | null;
  kraPin: string | null;
  payoutDetails: PayoutDetails;
  isCompany: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface OwnerTruck {
  id: string;
  registration: string;
  make: string;
  model: string;
  effectiveFrom: string;
  effectiveTo: string | null;
}

export interface OwnerTrailer {
  id: string;
  registration: string;
  typeCode: string;
  effectiveFrom: string;
  effectiveTo: string | null;
}

export interface OwnerDetail extends OwnerView {
  trucksCurrent: OwnerTruck[];
  trucksPast: OwnerTruck[];
  trailersCurrent: OwnerTrailer[];
  trailersPast: OwnerTrailer[];
}

export function listOwners(query: OwnerListQuery): Promise<Page<OwnerListItem>> {
  return api<Page<OwnerListItem>>(`/owners?${toListParams(query)}`);
}

export async function createOwner(input: CreateOwnerInput): Promise<void> {
  await api<void>('/owners', { method: 'POST', body: JSON.stringify(input) });
}

export function getOwner(id: string): Promise<OwnerDetail> {
  return api<OwnerDetail>(`/owners/${id}`);
}

export async function updateOwner(id: string, input: UpdateOwnerInput): Promise<void> {
  await api<void>(`/owners/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}
